module.exports = __webpack_public_path__ + "img/carpet.894358f8.png";